import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Spinner from './Spinner';
import InfiniteScrollSentinel from './InfiniteScrollSentinel';
import Button from './Button';
type InfiniteScrollProps = {
  isFetchingMore: boolean;
  onLoadMore?: () => void;
  onFetchMore: () => void;
  hasMore: boolean;
  loadMoreOnPageEnd?: boolean;
  loadMoreButtonText?: string;
  children: ReactNode;
};
export default function InfiniteScroll(t0) {
  const $ = _c(18);
  const {
    isFetchingMore,
    onLoadMore,
    onFetchMore,
    hasMore,
    loadMoreOnPageEnd: t1,
    loadMoreButtonText,
    children
  } = t0;
  const loadMoreOnPageEnd = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== isFetchingMore || $[1] !== loadMoreOnPageEnd) {
    t2 = loadMoreOnPageEnd && isFetchingMore && <div className="flex h-10 items-center justify-center"><Spinner color="gray" /></div>;
    $[0] = isFetchingMore;
    $[1] = loadMoreOnPageEnd;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== hasMore || $[4] !== isFetchingMore || $[5] !== loadMoreOnPageEnd || $[6] !== onFetchMore) {
    t3 = loadMoreOnPageEnd && !isFetchingMore && hasMore && <InfiniteScrollSentinel onIntersect={onFetchMore} />;
    $[3] = hasMore;
    $[4] = isFetchingMore;
    $[5] = loadMoreOnPageEnd;
    $[6] = onFetchMore;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== hasMore || $[9] !== loadMoreButtonText || $[10] !== loadMoreOnPageEnd || $[11] !== onLoadMore) {
    t4 = !loadMoreOnPageEnd && hasMore && <div className="flex items-center justify-center"><Button onClick={onLoadMore}>{loadMoreButtonText}</Button></div>;
    $[8] = hasMore;
    $[9] = loadMoreButtonText;
    $[10] = loadMoreOnPageEnd;
    $[11] = onLoadMore;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== children || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className="relative">{children}{t2}{t3}{t4}</div>;
    $[13] = children;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}